import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatchEventDetailsDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra la lista cronológica
 * de eventos del partido (goles, sanciones, etc.).
 */
@Component({
  selector: 'app-match-events-list',
  standalone: true,
  imports: [
    CommonModule,
    DecimalPipe,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './match-events-list.component.html',
  styleUrls: ['./match-events-list.component.scss']
})
export class MatchEventsListComponent {

  /**
   * Lista de todos los eventos del partido (ordenados por tiempo).
   */
  @Input({ required: true }) events!: MatchEventDetailsDTO[] | null;

  /**
   * Devuelve el nombre del icono de Material Design
   * basado en el tipo de evento.
   */
  public getIconForEvent(type: string): string {
    switch (type) {
      case 'goal':
        return 'sports_soccer'; // Icono de balón
      case 'sanction_yellow':
        return 'sticky_note_2'; // Icono de tarjeta
      case 'sanction_2m':
      case 'sanction_2m_1':
      case 'sanction_2m_2':
        return 'timer';
      case 'sanction_red':
        return 'style'; // Icono de tarjeta roja
      case 'sanction_blue':
        return 'book'; // La azul implica informe
      case 'timeout':
        return 'hourglass_empty';
      default:
        return 'radio_button_unchecked';
    }
  }

  /**
   * Devuelve un color (hex) para el icono
   * basado en el tipo de evento.
   */
  public getColorForEvent(type: string): string {
    switch (type) {
      case 'sanction_yellow':
        return '#FFC107'; // Amarillo
      case 'sanction_red':
        return '#F44336'; // Rojo
      case 'sanction_blue':
        return '#2196F3'; // Azul
      case 'goal':
        return '#002041'; // Azul RFEBM
      default:
        return '#6B7280'; // Gris
    }
  }

  /**
   * Traduce el tipo de evento a una etiqueta legible.
   */
  public formatEventType(type: string): string {
    switch (type) {
      case 'goal':
        return 'Gol';
      case 'sanction_yellow':
        return 'Amarilla';
      case 'sanction_2m':
      case 'sanction_2m_1':
      case 'sanction_2m_2':
        return 'Exclusión (2 min)';
      case 'sanction_red':
        return 'Roja';
      case 'sanction_blue':
        return 'Azul';
      case 'timeout':
        return 'Tiempo Muerto';
      default:
        return type;
    }
  }
}
